import axios from 'axios'

import {
  LANG_KEY,
  CURRENCY_KEY,
  DEFAULT_LANG,
  API_ENDPOINT,
  DEFAULT_CURRENCY,
} from '@/constants'
import { TCurrency, TLang } from '@/types'
import { getStorageValue } from '@/utils'

export const apiRequest = axios.create({
  baseURL: `${API_ENDPOINT}/`,
})

apiRequest.interceptors.request.use(function (config) {
  const currency = getStorageValue<TCurrency>(CURRENCY_KEY)
  const language = getStorageValue<TLang>(LANG_KEY)
  // @ts-ignore
  config.headers = {
    ...config.headers,
    'ngrok-skip-browser-warning': true,
    language: `${language ?? DEFAULT_LANG}`,
    currency: `${currency?.name ?? DEFAULT_CURRENCY}`,
  }

  return config
})
